import { collection, doc, setDoc, serverTimestamp, query, where, getDocs } from 'firebase/firestore';
import { db } from '../config/firebase';

export const checkDuplicateFeedback = async (phoneNumber, eventId) => {
  try {
    const feedbackRef = collection(db, 'feedbackSubmissions');
    const q = query(
      feedbackRef,
      where('phoneNumber', '==', phoneNumber),
      where('eventId', '==', eventId)
    );
    const snapshot = await getDocs(q);
    return !snapshot.empty;
  } catch (error) {
    console.error('Error checking duplicate feedback:', error);
    return false;
  }
};

export const getFeedbackCount = async (eventId) => {
  try {
    const feedbackRef = collection(db, 'feedbackSubmissions');
    const q = query(feedbackRef, where('eventId', '==', eventId));
    const snapshot = await getDocs(q);
    return snapshot.size;
  } catch (error) {
    console.error('Error getting feedback count:', error);
    return 0;
  }
};

/**
 * @param {Object} data - Form data
 * @param {Object} eventConfig - Full event object from events.js
 */
export const saveFeedback = async (data, eventConfig) => {
  try {
    const isDuplicate = await checkDuplicateFeedback(data.phoneNumber, eventConfig.id);
    if (isDuplicate) {
      return {
        success: false,
        error: 'Feedback has already been submitted from this number for this event.',
        isDuplicate: true
      };
    }

    const feedbackRef = doc(collection(db, 'feedbackSubmissions'));

    await setDoc(feedbackRef, {
      eventId: eventConfig.id,                        // links to meetingRegistrations
      source: eventConfig.feedback.source,
      phoneNumber: data.phoneNumber,
      name: data.name,
      age: Number(data.age),
      disability: data.disability,
      disabilityIsOther: data.disabilityIsOther ?? false,
      cityOfResidence: data.cityOfResidence,
      whatYouEnjoyed: data.whatYouEnjoyed,
      improvementSuggestions: data.improvementSuggestions,
      attendAgain: data.attendAgain,                  // boolean for filtering next invite list
      timestamp: serverTimestamp()
    });

    return { success: true };
  } catch (error) {
    console.error('Error saving feedback:', error);
    return { success: false, error: error.message };
  }
};